import React, { Fragment, useState, useEffect, useRef } from "react";
// import SubFooter from '../_shared/subFooter/subFooter';
import { ProgressBar } from "primereact/progressbar";
import { Toast } from "primereact/toast";
import { useTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import SubHeader from "../../_shared/SubHeader/subHeader";
import logo from "../../assets/images/logos/_Logo-Symple.svg";
import { config as globalConfig } from "../../config";
import * as globalUtils from "../../helpers/utils";
import { isArabic } from "../../helpers/utils";
import {
  updateCallingApi,
  updateCurrentPolicy,
  updateDefaultValues,
  updateLoading,
  updateLoggedInUser,
  updateQuotationDetails,
  updateUid,
} from "../../redux/actions/renewal";
import * as renewalService from "../../services/renewal-service";
import config from "./helpers/renewal.config";

let isApiCalled = false;

const RenewalWrapperApplication = (props) => {
  const message = useRef(null);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.renewal.loading);
  const policyData = useSelector((state) => state.renewal.policyData);
  const isLoggedIn = useSelector((state) => state.renewal.isLoggedIn);
  const [showHoldOnLoading, setShowHoldOnLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const callingApi = useSelector((state) => state.renewal.callingApi);
  const uid = searchParams.get("uid");
  localStorage.setItem("renewalUid", uid);
  let lang = searchParams.get("lang") || "ar";
  let direction = "ltr";
  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    } else {
      i18n.changeLanguage("ar");
    }

    if (i18n.language === "en") {
      lang = "en";
      direction = "ltr";
    } else {
      lang = "ar";
      direction = "rtl";
    }

    document.body.dir = direction;
    document.documentElement.lang = lang;
  }, []);

  useEffect(() => {
    if (searchParams.get("uid")) setShowHoldOnLoading(true);
    else setShowHoldOnLoading(false);
  }, [searchParams.get("uid")]);

  const isLoggedUser = isLoggedIn || !!uid;

  if (!isLoggedUser && !["/renewal", "/renewal/"].includes(location.pathname)) {
    window.location.href = globalConfig.prefixRouting + "renewal";
    // navigate("/renewal",{replace:true});
    return <Outlet />;
  }

  const getUsername = () => {
    return isLoggedIn && policyData && policyData.customerInfo
      ? isArabic(props.i18n.language)
        ? policyData.customerInfo.fullArabicName.split(" ")[0][0] +
          "****** " +
          policyData.customerInfo.fullArabicName.split(" ")[1][0] +
          "******"
        : policyData.customerInfo.fullEnglishName.split(" ")[0][0] +
          "****** " +
          policyData.customerInfo.fullEnglishName.split(" ")[1][0] +
          "******"
      : "";
  };

  return (
    <Fragment>
      <Toast ref={message} />
      {loading && (
        <>
          <div className="loader-overlay">
            {showHoldOnLoading ? (
              <div className="loading-box-hold-container">
                <img src={logo} alt="" />
                <span>{t("holdon_loading")}</span>
              </div>
            ) : (
              <img src={logo} alt="" />
            )}
          </div>
          <ProgressBar
            mode="indeterminate"
            style={{ height: "6px" }}
          ></ProgressBar>
        </>
      )}
      <div className={isArabic(props.i18n.language) ? "ar" : ""}>
        <SubHeader
          username={getUsername()}
          hideUsername={!isLoggedIn}
          steps={config.steps}
        />
        <props.component {...props} />
      </div>
    </Fragment>
  );
};

export default withTranslation()(RenewalWrapperApplication);
